import React, { useState } from "react";
import { Search } from "lucide-react";

export default function GovSearchEngine() {
  const [query, setQuery] = useState("");
  const [country, setCountry] = useState("india");

  const handleSearch = () => {
    if (!query.trim()) {
      alert("Please enter a search term");
      return;
    }

    let searchUrl = "";

    if (country === "india") {
      searchUrl = `https://www.google.com/search?q=site:gov.in+${encodeURIComponent(query)}`;
    }

    window.open(searchUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <h1 className="text-3xl font-bold text-blue-600 mb-6">
        Government Search Portal
      </h1>

      <div className="bg-white p-6 rounded-lg shadow-md max-w-3xl">
        
        {/* SEARCH BAR */}
        <div className="flex gap-3 mb-4">
          <div className="flex-1 relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search government services, schemes, portals..."
              className="w-full pl-10 pr-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <button
            onClick={handleSearch}
            className="px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Search
          </button>
        </div>

        {/* COUNTRY FILTER */}
        <div className="flex gap-6 mb-4">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="country"
              checked={country === "india"}
              onChange={() => setCountry("india")}
            />
            India (.gov.in)
          </label>
        </div>

        <p className="text-sm text-gray-500">
          This search redirects to official government websites only.
        </p>
      </div>
    </div>
  );
}
